:host {
  .mail-error {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;

    &__title {
      color: #333333;
      color: var(--font-primary);
      font-size: 21px;
      letter-spacing: 0;
      line-height: 28px;
      text-align: center;
    }

    &__image {
      display: flex;
      justify-content: center;
      margin: 20px auto;
    }

    &__description {
      color: #979ba4;
      color: var(--font-tertiary);
      font-size: 14px;
      letter-spacing: 0;
      line-height: 21px;
      text-align: center;
      max-width: 60%;
      margin: 0 auto 30px;
    }

    &__action {
      display: flex;
      justify-content: center;

      button {
        cursor: pointer;
        background: #0098ff;
        background: var(--blue);
        color: white;
        padding: 10px 20px;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 18px;
        text-align: center;
        margin: 0 5px;
        border-radius: 6px;
        box-sizing: border-box;
        border: none;

        &:focus {
          outline: none;
        }

        &:hover {
          transition: all 0.3s;
          background: #007ee2;
          background: var(--blue-hover);
          color: white;
        }

        &:disabled {
          background: rgba(0, 0, 0, 0.12);
          background: var(--bg-disabled-button);
          border: none;
          color: rgba(0, 0, 0, 0.26);
          color: var(--font-disabled);
          cursor: not-allowed;
        }
      }
    }

    &--full {
      background: white;
      background: var(--bg-primary);
      padding: 30px;
      box-sizing: border-box;
      border-radius: 6px;
    }
  }
}
